import styled from 'styled-components'

import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'
import { Image as ImageBase } from '@src/Application/Interfaces/Atoms/Image'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Button = styled(ButtonBase)`
    width: 100%;

    button {
        width: 100%;

        & > span:first-child {
            ${(props) => props.theme.typo.bodyM};
            ${(props) => props.theme.fontWeight.medium};
            text-decoration: none;
            white-space: normal;
        }
    }
`

export const Link = styled(LinkBase)`
    display: flex;
    align-items: center;
    text-decoration: none;
    ${(props) => props.theme.typo.bodyL}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.g600};
`

export const Image = styled(ImageBase)`
    margin-right: 20px;
`

export const TitleSection = styled(TitleSectionBase)`
    padding-bottom: 100px;
    background-color: ${(props) => (props.mode === 'Dark' ? props.theme.color.p600 : props.theme.color.white)};

    ${(props) =>
        props.mode === 'Dark' &&
        `
        ${Link} {
            color: ${props.theme.color.white};
        }

        ${Button} {
            .root:hover {
                background-color: ${props.theme.color.p500};
            }
        }
    `}
`

export const Content = styled.div`
    min-height: 80px;
`
